

    <div class="card card-info" [ngClass]="{'dark-bg' : isDark }">
      <div class="card-header">User Permissions</div> 
      <div class="col-10 justify-content-center">
      <div class="card-body">

<mat-tab-group animationDuration="500ms">
  <mat-tab label="Module Permissions">
    <br>
    <div class="col-12">
      <mat-form-field>
        <mat-label [ngClass]="{'dark-bg' : isDark }">Select User</mat-label>
        <mat-select [(ngModel)]="selectedUser" (ngModelChange)="getUserPermissionByUserName()">
          <mat-option>None</mat-option>
          <mat-option *ngFor="let user of userList" [value]="user.UserName">
            {{user.UserName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
  
      <mat-checkbox class="float-right"  (change)="selectAllcheckedChange()" [(ngModel)]="selectAll">Select All</mat-checkbox>     
  
    </div>

    <table class="table table-sm mt-2 table-bordered" [ngClass]="{'dark-bg' : isDark }">  
      <thead class="thead-light"  [ngClass]="{'dark-input-field' : isDark }" [ngClass]="{'thead-light' : !isDark }">
          <tr>
            <th style="width: 40%" scope="col">Module Name</th>
            <th class="text-center" style="width: 12%" scope="col">Module</th>
            <th class="text-center" style="width: 12%">Read</th>
            <th class="text-center" style="width: 12%">Create</th>
            <th class="text-center" style="width: 12%" scope="col">Approve</th>
            <th class="text-center" style="width: 12%" scope="col">Delete</th>
          </tr>
        </thead>


      <tbody class="ml-1">                              
            <tr  *ngFor="let item of userPermissionArray; let i = index">                           
                <td>{{item.moduleName}}</td>
                <td class="p-2 text-center"><mat-checkbox  [(ngModel)]="item.module"></mat-checkbox></td>                    
                <td class="p-2 text-center"><p *ngIf="item.read==null">-</p><mat-checkbox *ngIf="item.read!=null" [(ngModel)]="item.read"></mat-checkbox></td>                    
                <td class="p-2 text-center"><p *ngIf="item.create==null">-</p><mat-checkbox *ngIf="item.create!=null" [(ngModel)]="item.create"></mat-checkbox></td>  
                <td class="p-2 text-center"><p *ngIf="item.approve==null">-</p><mat-checkbox *ngIf="item.approve!=null" [(ngModel)]="item.approve"></mat-checkbox></td>  
                <td class="p-2 text-center"><p *ngIf="item.delete==null">-</p><mat-checkbox *ngIf="item.delete!=null" [(ngModel)]="item.delete"></mat-checkbox></td>                                                      
            </tr>  
                                            
      </tbody>
      <br>
      <tfoot>
        <tr>
          <td colspan="5">
            <button type="button" (click)="saveUserPermissionBtnClick()" class="btn btn-success"><i class="fa fa-save"></i> Save</button>
            <button type="button" (click)="deleteUserPermissionBtnClick()" class="btn btn-danger ml-2"><i class="fa fa-trash-alt"></i> Delete</button>
            <button type="button" (click)="clearPanel()" class="btn btn-warning ml-2"><i class="fa fa-refresh"></i> Clear</button>
          </td>
        </tr>   
      </tfoot>
  </table> 

  </mat-tab>
</mat-tab-group>



</div>     
</div>
</div>

    
   




